import { util } from '@/api/util';
import { getPositionByUnit } from './org';
export const transServerSearch = (list) => {
    const searchList = list.map(item => {
        const contactPYName = util.toPinyin(item.qiyeNickName);
        const pinyinName = item.pinyinName || item.qiyeNickName.split('').map((n) => util.toPinyin(n));
        const contactPYLabelName = pinyinName.reduce((pre, cur) => pre + cur.charAt(0).toLocaleLowerCase(), '');
        const contactName = item.qiyeNickName;
        const accountName = item.email;
        let avatar = '';
        let avatarPendant = '';
        if (item.iconVO) {
            avatar = item.iconVO.mediumUrl;
            avatarPendant = item.iconVO.pendantUrl;
        }
        return {
            id: item.qiyeAccountId,
            contactPYName,
            contactPYLabelName,
            contactName,
            accountName,
            position: getPositionByUnit(item.unitIdList),
            type: 'enterprise',
            avatar,
            avatarPendant,
            visibleCode: item.showCode,
            accountType: item.type,
        };
    });
    return searchList;
};
export const transContactModel2ContactSearch = (list) => {
    return list.map(item => {
        const { contact: { id, contactName, accountName, contactPYName, contactPYLabelName, position, type, avatar, avatarPendant, visibleCode, accountType, hitQueryEmail, remark, hitQuery = [], }, } = item;
        const emailCount = item.contactInfo.filter((info) => info.contactItemType === 'EMAIL').length;
        return {
            id,
            contactPYName,
            contactPYLabelName,
            contactName,
            accountName,
            position,
            type,
            avatar,
            avatarPendant,
            visibleCode,
            accountType,
            hitQueryEmail,
            hitQuery,
            remark,
            emailCount,
        };
    });
};
export const transOrg2OrgSearch = (list) => {
    return list.map(item => {
        const { id, orgName, orgPYName, orgRank, hitQuery, type, visibleCode, originId } = item;
        return {
            id,
            orgName,
            orgPYName,
            type,
            orgRank,
            visibleCode,
            hitQuery,
            originId,
        };
    });
};
export const transEdmContact2EdmContactSearch = (list) => {
    const res = [];
    list.forEach(item => {
        const { contact: { id, contactName, accountName, contactPYName, contactPYLabelName, type }, customerOrgModel, } = item;
        if (customerOrgModel) {
            res.push({
                id,
                orgId: '',
                _lastUpdateTime: 0,
                contactPYName,
                contactPYLabelName,
                contactName,
                accountName,
                type: type,
            });
        }
    });
    return res;
};
export const transEdmOrg2EdmOrgSearch = (list) => {
    const res = [];
    list.forEach(item => {
        const { id, _company, _lastUpdateTime, orgName, orgPYName, type, orgRank, customerType, hitQuery, customerRole, originId } = item;
        res.push({
            id,
            _lastUpdateTime,
            _company,
            orgName,
            orgPYName,
            type,
            orgRank,
            customerType: customerType,
            hitQuery,
            customerRole,
            originId,
        });
    });
    return res;
};
